<script>
  import { onMount, createEventDispatcher } from 'svelte';
  import { navigate } from 'svelte-routing';
  import Card, { PrimaryAction, Content, Media } from '@smui/card';
  import { apiGet } from '../httpCommon';

  import GooglePlaceSearch from './GooglePlaceSearch.svelte';
  import Carousel from './Carousel.svelte';

  let searching = false;
  let results;
  let place;

  const emit = createEventDispatcher();

  async function onPlace(ev) {
    place = ev.detail;

    if (place) {
      if (place.place_id) {
        try {
          searching = true;
          results = await apiGet(['venues/search', place.place_id]);
        } finally {
          searching = false;
        }
      }
    } else {
      results = [];
    }
  }

  function selectVenue(venue) {
    navigate(venue.slug);
  }
</script>

<div class="outer">
  <div class="content">
    <div class="search">
      <div class="column">
        <h2 class="title">
          Find Food Disco<br class="hide-desk" />
          at your location
        </h2>
        <div class="search-box ">
          <h3 class="search-title">See your daily menu</h3>
          <GooglePlaceSearch on:result={onPlace} />
        </div>
        {#if searching}
          <div>Searching for venues...</div>
        {:else if results}
          {#if results.length}
            <h3 class="result">Choose your building or company</h3>
            {#each results as result}
              <div class="venue">
                <button
                  class="button"
                  on:click={() => selectVenue(result.venue)}
                >
                  {result.venue.venue_name}
                </button>
                <!-- Card variant="outlined">
            <PrimaryAction on:click={() => selectVenue(result.venue)}>
              <Content>{result.venue.venue_name}</Content>
            </PrimaryAction>
          </Card -->
              </div>
            {/each}

            <!-- <h3 class="result">
              There aren't any Food Disco events scheduled at {place.name}
              <br />
              <br />
              Would you like some? Let's talk about it
              <br />
              <br />
              Email <a href="mailto:info@fooddisco.co.uk" target="_new">info@fooddisco.co.uk</a> and our team will contact you
            </h3> -->
          {:else}
            <h3 class="result">
              There aren't any Food Disco events scheduled at
              {place.name}
              <br />
              <br />
              Would you like some? Let's talk about it
              <br />
              <br />
              Email
              <a href="mailto:info@fooddisco.co.uk" target="_new"
                >info@fooddisco.co.uk</a
              >
              and our team will contact you
            </h3>
          {/if}
        {/if}
      </div>
    </div>
  </div>
  <div class="filler">
    <Carousel />
  </div>
</div>

<style>
  .outer {
    display: flex;
    flex-flow: column;
    height: calc(100vh - 118px);
  }

  @media screen and (max-width: 767px) {
    .outer {
      height: calc(100vh - 140px);
    }
  }
  .content {
    background: url('/background.png') center/cover no-repeat;
    min-height: 500px;
    padding-top: 50px;
  }

  @media only screen and (max-width: 570px) {
    .content {
      padding-top: 30px;
    }
  }

  .filler {
    flex-direction: column;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #3d3b3b;
  }

  @media only screen and (max-width: 768px) {
    .filler {
      display: none;
    }
  }

  .search {
    display: flex;
    justify-content: center;
  }
  .column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .venue {
    max-width: 250px;
    margin: 10px;
  }

  h3 {
    font-size: 18px;
    text-align: center;
    font-weight: 600;
    line-height: 140%;
  }
  .title {
    font-size: 28px;
    margin-bottom: 36px;
    text-align: center;
  }

  @media only screen and (max-width: 570px) {
    .title {
      font-size: 24px;
      max-width: 300px;
    }
  }

  .search-title {
    font-size: 18px;
    margin-bottom: 19px;
    margin-top: 0px;
  }

  @media only screen and (max-width: 570px) {
    .search-title {
      font-size: 18px;
      padding: 0px 60px;
    }
  }

  .search-box {
    padding: 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #dcdcdf !important;
  }

  @media only screen and (max-width: 570px) {
    .search-box {
      width: calc(100% - 40px);
      padding: 26px 0 34px 0;
    }
  }

  .result {
    margin-top: 36px;
  }
  .button {
    font-weight: bold;
    border-radius: 0;
    margin: 0;
    padding: 1px 20px;
    border: 0;
    background-color: #3d3b3b;
    color: white;
    cursor: pointer;
    line-height: 41px;
  }

  .button:hover {
    background-color: #f0913f;
    transition: background-color 0.4s ease 0s;
  }

  @media screen and (min-width: 768px) {
    .hide-desk {
      display: none;
    }
  }
</style>
